export enum ETypeChart {
  SCALAR = 'SCALAR',
  OCTAVE = 'OCTAVE',
  SPECTRUM = 'SPECTRUM',
  TIMING = 'TIMING'
}
